<template>
  <div>
    <div v-if="form">
      <div>
        <p><b>ההבדלים בין המשרות: (ניתן להשאיר ריק אם אין הבדל):</b></p>
        <textarea maxlength="255" placeholder="..." v-model="form.data.related_resource.fields.message.value"></textarea>
        <p>{{form.data.related_resource.fields.message.value.length}}/255</p>
      </div>
      <checkbox v-if="bonded_related_resource == undefined" v-model="form.data.bonded_related_resource.is_used" :checked="form.data.bonded_related_resource.is_used">
        קשר את {{ payload.related_resource.leader.position.title }} ל- {{ payload.related_resource.follower.position.title }}?
      </checkbox>
    </div>
    <div v-else class="is-flex is-align-items-center is-justify-content-center">
      <div class="loading"></div>
    </div>
    <div class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import Checkbox from '@/components/Checkbox'
export default {
  name: 'related-resource-message-prompt',
  props: ['payload'],
  data () {
    return {
      is_loading: false,
      form: undefined,
      bonded_related_resource: undefined
    }
  },
  created () {
    this.$network_utils.getRelatedResource({ id: this.payload.related_resource.id }).then(response => {
      this.setForm(response)
      this.setBondedRelatedResource()
    })
  },
  methods: {
    setBondedRelatedResource () {
      this.$network_utils.getRelatedResources({
        follower_type: 'Position',
        follower_id: this.payload.related_resource.leader.position.id,
        approval_statuses: 'true,NULL'
      }).then(response => {
        this.bonded_related_resource = response.filter(related_resource => related_resource.leader.position.id == this.payload.related_resource.follower.position.id)[0]
        if (this.bonded_related_resource != undefined) {
          if (this.form.data.related_resource.fields.message.value.length == 0) {
            this.form.data.related_resource.fields.message.value = this.bonded_related_resource.message
          }
          this.form.data.bonded_related_resource.request_details.method = 'put'
          this.form.data.bonded_related_resource.request_details.url = '/related_resources/' + this.bonded_related_resource.id
        }
      })
    },
    setForm (form_data) {
      this.form = new this.$form({
        related_resource: {
          fields: {
            message: {
              value: form_data.message || '',
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: 'put',
            url: '/related_resources/' + form_data.id,
            headers: 'admin_headers'
          },
          is_used: true
        },
        bonded_related_resource: {
          fields: {
            follower_type: {
              value: 'Position',
              has_error: false,
              validations: []
            },
            leader_type: {
              value: 'Position',
              has_error: false,
              validations: []
            },
            leader_id: {
              value: this.payload.related_resource.follower.position.id,
              has_error: false,
              validations: []
            },
            follower_id: {
              value: this.payload.related_resource.leader.position.id,
              has_error: false,
              validations: []
            },
            message: {
              value: '',
              has_error: false,
              validations: []
            }
          },
          request_details: {
            method: 'post',
            url: '/related_resources/',
            headers: 'admin_headers'
          },
          is_used: true
        }
      })
    },
    submit () {
      this.form.data.bonded_related_resource.fields.message.value = this.form.data.related_resource.fields.message.value
      let response = this.form.mySubmit()
      if (response === false) {
        return
      }
      this.is_loading = true
      response.promise.then((response) => {
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'עודכן' })
        this.remove(this.payload)
      })
    },
    ...mapMutations('modals', ['remove'])
  },
  components: {
    Checkbox
  }
}
</script>
